<template>
  <div class="piBox">
    <el-select
      v-model="dynamicValue[0]"
      style="flex: 1"
      placeholder="请选择"
    >
      <el-option
        v-for="(lba, i) in timeOptions"
        :key="i"
        :label="proxy.$t(lba.label)"
        :value="lba.value"
      />
    </el-select>
    <el-input-number
      v-if="dynamicValue[0] == 'CUSTOM'"
      v-model="dynamicValue[1]"
      style="flex: 1; margin: 0 6px"
      :min="1"
      :max="10"
      controls-position="right"
      @change="handleChange"
    />
    <el-select
      v-if="dynamicValue[0] == 'CUSTOM'"
      v-model="dynamicValue[2]"
      style="flex: 1"
      placeholder="请选择"
    >
      <el-option
        v-for="(lba, i) in unitOptions"
        :key="i"
        :label="proxy.$t(lba.label)"
        :value="lba.value"
      />
    </el-select>
  </div>
</template>
<script setup lang="ts">
import { getCurrentInstance, ref, watch } from 'vue';
import { timeOptions, unitOptions } from '../index.ts';

const { proxy } = getCurrentInstance();

const modelValue = ref('');
const dynamicValue = ref([]);
defineProps({
  timeRangeType: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => dynamicValue.value,
  ([type, value, unit]) => {
    if (type === 'CUSTOM') {
      modelValue.value = `CUSTOM,${value},${unit}`;
    } else {
      modelValue.value = type;
    }
  },
  { deep: true, immediate: true },
);
watch(
  () => modelValue.value,
  (val) => {
    let parts = [];
    if (val) {
      parts = val.split(',');
    }
    if (parts.length == 0) {
      dynamicValue.value = ['WEEK', undefined, undefined];
    } else if (parts[0] == 'CUSTOM') {
      dynamicValue.value = ['CUSTOM', parts[1] == 'undefined' ? 6 : parts[1], parts[2] == 'undefined' ? 'BEFORE_DAY' : parts[2]];
    }
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped>
.piBox {
  width: 100%;
  display: flex;
}
</style>
